// Admin me tareekh/samay hamesha is desh ke timezone me dikhte hain, dekhne wale ke system/browser ke nahi.
// DB me time UTC me save hota hai (server me koi badlav nahi); yahan sirf dikhate waqt Tanzania (EAT, UTC+3) me badalte hain.
// Isliye kisi bhi desh ka user register kare ya admin kisi bhi desh se dekhe, time yahi dikhega.
export const COUNTRY_TIMEZONE = "Africa/Dar_es_Salaam";

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: COUNTRY_TIMEZONE,
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

// "dd/mm/yyyy" (toLocaleDateString("en-GB") jaisa hi, bas desh ke timezone me)
export const formatCountryDate = (value) => {
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "Invalid Date" : dateFormatter.format(d);
};

// Desh me aaj ki tareekh "yyyy-mm-dd" (UTC ki nahi)
export const todayInCountry = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: COUNTRY_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
